import styled from "styled-components";

export const StyledReturnCart = styled.div`
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  min-height: 100vh;
  background: var(--rms-v2-page-bg);
  border-left: 0;
  border-right: 0;

  .select {
    font-size: 14px;
    color: var(--rms-v2-text-body);
    font-weight: 700;
    margin-left: 1rem;
    margin-bottom: 10px;
  }

  .return-request {
    padding: 15px;
    box-shadow: 0px -10px 20px 0px rgba(0, 0, 0, 0.1);
    position: fixed;
    width: 100%;
    z-index: 7;
    background: var(--rms-v2-surface);
    bottom: 25px;
  }

  .request-consent-label {
    grid-column: 1 / -1;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 8px;
    color: var(--rms-v2-text-muted);
    font-size: 12px;
    font-weight: 500;
    position: relative;
  }

  .request-consent-card {
    background: var(--rms-v2-surface-muted);
    border: 1px solid var(--rms-v2-border-soft);
    border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
    padding: 10px 12px;
  }

  .request-consent-card.error {
    background: var(--rms-v2-danger-soft);
    border-color: var(--rms-v2-danger);
    color: var(--rms-v2-danger);
  }

  .request-consent-label input {
    height: 14px;
    left: 0;
    margin: 0;
    opacity: 0;
    position: absolute;
    top: 0;
    width: 14px;
  }

  .request-consent-check {
    margin-top: 1px;
  }

  .request-consent-text {
    font-size: 12px;
  }

  .request-consent-copy {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .request-consent-copy strong {
    color: var(--rms-v2-danger);
    font-size: 13px;
    font-weight: 900;
  }

  .request-creating-loader {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background: var(--rms-v2-surface);
  }

  .request-creating-loader-text {
    margin-top: 10px;
    font-size: 16px;
    text-align: center;
  }

  .empty-return-cart {
    min-height: 200px;
    padding: 20px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background: var(--rms-v2-surface);
    font-weight: 600;
  }

  .empty-return-cart-image {
    height: 100px;
  }

  .empty-return-cart-text {
    margin-top: 1.5rem;
  }

  .empty-return-cart-button {
    margin: 20px 0 !important;
  }

  .help {
    font-weight: 700;
    font-size: 12px;
    color: var(--color-primary);
    margin: 0px 20px 100px;
    text-decoration: underline;
  }

  .overlay {
    position: fixed;
    height: 100vh;
    bottom: 0px;
    background: var(--rms-v2-surface);
    width: 100%;
    z-index: 99;
    opacity: 0.6;
    pointer-events: none;
  }

  `;

export const StyledExchange = styled.div`
  padding: ${(props) =>
    props.location === "/success" ? "30px 0px" : "0 20px 130px"};
  position: relative;
  background: var(--rms-v2-section-bg);

  .cart-wrapper {
    background: var(--rms-v2-surface) !important;
    border: 0 !important;
    border-radius: ${(props) => (props.rounded ? "10px" : "0px")} !important;
    box-shadow: none !important;
    margin-bottom: 12px;
    padding: 12px !important;
    overflow: hidden;
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box;

    .exchange-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      position: relative;

      .return-item-box {
        margin-top: 0;
      }

      .exchange-box {
        display: flex;
        padding: 0px 0px;
        border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
        flex-direction: row;
        flex: 0.45;

        .details {
          margin-left: 1rem;
          width: 100%;
        }

        .return-label {
          font-size: 12px;
          color: var(--rms-v2-surface);
          position: absolute;
          top: -1rem;
          right: -1rem;
          padding: 2px 10px 4px;
          border-top-right-radius: 8px;
          border-bottom-left-radius: 8px;
        }

        .image-preview-container {
          width: 100%;
          max-width: 60px;
          height: 60px;
          overflow: hidden;
          margin-top: 10px;
          border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
        }

        .image-preview {
          width: 100%;
          height: 100%;
          object-fit: contain;
          border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
        }

        .description,
        .quantity {
          font-size: 16px;
          margin: 7px 0;
          color: var(--rms-v2-text-body);
        }

        .title,
        .price {
          font-size: 16px;
          margin: 7px 0;
          font-weight: 700;
          color: ${(props) => props.primaryColor};
        }

        .price {
          color: var(--rms-v2-text-body);
        }

        .stock {
          color: red;
          margin-left: auto;
        }
      }

      .return-icon {
        display: none;
        align-items: center;
        flex: 0.1;
        margin: 10px 0px;
        justify-content: center;
        height: 100%;

        svg {
          position: absolute;
          top: -14px;
        }
      }
    }

    .return-type,
    .return-reason {
      font-size: 16px;
    }
  }

  .cart-product-title-row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 28px;
    gap: 8px;
    align-items: center;
  }

  .cart-product-title-row .title {
    margin-top: 0 !important;
  }

  .cart-product-remove-icon {
    width: 26px;
    height: 26px;
    border: 0;
    background: transparent;
    color: var(--rms-v2-danger);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0;
  }

  .cart-product-remove-icon svg {
    width: 17px;
    height: 17px;
    stroke: currentColor;
  }

  .pickup-address-section {
    display: none;
  }

  .price-details {
    padding: ${(props) =>
      props.location === "/return-cart" ? "12px 0px 120px" : "20px 0px"};
    flex-direction: column;
    display: flex;
    width: 100%;
    color: var(--rms-v2-text-title);
    position: relative;
    background: transparent;
    gap: 12px;

    #Returnmode {
      border-bottom: ${(props) =>
        props.refundModeError ? "1px solid red" : "none"};
    }

    .box {      
      background: transparent;
      margin: 0px 0px;
      width: 100%;
      border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
      display: flex;
      flex-direction: column;
      gap: 12px;

      .v2-refund-method-container {
        background: var(--rms-v2-surface);
        padding: 14px;
        margin-bottom: 12px;
        border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
        box-shadow: 0 2px 8px rgba(16, 24, 40, 0.06);
      }

      .v2-reason-first-transfer-form {
        border-top: 1px solid var(--rms-v2-border, #e5e7eb);
        padding-top: 12px;
      }

      .v2-refund-details-item-breakdown {
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin: 2px 0 12px;
      }

      .v2-refund-details-item {
        border-bottom: 1px solid var(--rms-v2-border);
        padding: 0 0 9px;
      }

      .v2-refund-details-item:last-child {
        border-bottom: 0;
        padding-bottom: 0;
      }

      .v2-refund-details-item-main {
        align-items: baseline;
        display: flex;
        gap: 12px;
        justify-content: space-between;
      }

      .v2-refund-details-item-main p,
      .v2-refund-details-item-main strong,
      .v2-refund-details-item-rule {
        margin: 0;
      }

      .v2-refund-details-item-main p {
        color: var(--rms-v2-text-title);
        font-size: 14px;
        font-weight: 400;
        min-width: 0;
      }

      .v2-refund-details-item-main strong {
        color: var(--rms-v2-text-title);
        font-size: 14px;
        font-weight: 500;
        flex-shrink: 0;
        white-space: nowrap;
      }

      .v2-refund-details-item-rule {
        color: var(--rms-v2-text-muted);
        font-size: 12px;
        margin-top: 3px;
      }

      .v2-refund-details-item-error {
        color: var(--rms-v2-danger);
        font-size: 12px;
        margin: 6px 0 0;
      }

      .title {
        font-size: 14px;
        font-weight: 700;
        color: ${(props) => props.primary_color};
      }

      .v2-refund-method-title {
        color: var(--rms-v2-text-title);
        text-align: left;
        margin: 0;
      }

      .v2-refund-method-header {
        align-items: center;
        display: flex;
        gap: 10px;
        justify-content: space-between;
        margin: 0 0 12px;
      }

      .v2-refund-mode-change {
        align-items: center;
        background: transparent;
        border: 0;
        color: ${(props) => props.primary_color};
        cursor: pointer;
        display: inline-flex;
        font-size: 12px;
        font-weight: 900;
        gap: 2px;
        padding: 2px 0;
      }

      .v2-refund-mode-change svg {
        height: 16px;
        width: 16px;
      }

      .v2-refund-mode-list {
        display: flex;
        flex-direction: column;
        gap: 0;
        width: 100%;
        animation: v2ActionSlideDown 180ms ease-out;
      }

      .v2-refund-mode-list.expanded {
        gap: 10px;
      }

      .MuiButtonBase-root.MuiRadio-root {
        padding: 5px 9px;
      }

      .know {
        font-size: 12px;
      }

      .radio-label,
      .refund-preference,
      .refund-note {
        font-size: 13px;
      }
    }

    .address {
      padding: ${(props) =>
        props.location === "/success" ? "0px 1.25rem" : "0px !important"};
    }
  }

  .payment-method-card {
    background: var(--rms-v2-surface);
    border: 1px solid var(--rms-v2-border);
    border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
    box-shadow: 0 2px 8px rgba(16, 24, 40, 0.06);
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin: 0;
    padding: 14px;
    width: 100%;
  }

  .payment-method-title {
    color: var(--rms-v2-text-title);
    font-size: 14px;
    font-weight: 700;
    margin: 0;
  }

  .payment-method-error {
    border-color: var(--rms-v2-danger);
  }

  .payment-method-error .payment-method-title {
    color: var(--rms-v2-danger);
  }

  .payment-method-options {
    display: grid;
    gap: 10px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    width: 100%;
  }

  .payment-method-option {
    align-items: center;
    background: var(--rms-v2-surface-muted);
    border: 1px solid var(--rms-v2-border);
    border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
    color: var(--rms-v2-text-title);
    cursor: pointer;
    display: flex;
    font: inherit;
    font-size: 13px;
    font-weight: 700;
    gap: 10px;
    min-height: 44px;
    padding: 10px 12px;
    text-align: left;
  }

  .payment-method-option.selected {
    background: ${(props) => `${props.primary_color}08`};
    border-color: ${(props) => props.primary_color};
  }

  .payment-method-check {
    flex: 0 0 18px;
  }

  .products-return .accordion {
    border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
  }

  .product-details {
    width: 100%;
    color: var(--rms-v2-text-title);
    font-weight: 500;
    font-size: 1rem;
    margin: ${(props) =>
      props.location === "/return-cart"
        ? "0px 20px 20px"
        : props.location === "/tracking"
          ? "0px"
          : "1rem"};
  }

  .products-return {
    .accordion {
      border-radius: 0px;
      .MuiAccordionDetails-root {
        padding: 0px;
      }
    }
  }

  .v2-flat-cart-list {
    background: transparent;
    border: 0;
    border-radius: 0;
    box-shadow: none;
    padding: 0;
    margin-bottom: 0;
  }

  .v2-flat-cart-list .cart-products {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
  }

  .v2-flat-cart-list .cart-products > .MuiGrid-item {
    padding: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
    flex-basis: 100% !important;
    border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
    box-sizing: border-box;
  }

  .warranty-review-flow {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
  }

  .warranty-review-card {
    background: var(--rms-v2-surface);
    border: 1px solid var(--rms-v2-border-soft);
    border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
    box-shadow: 0 2px 8px rgba(16, 24, 40, 0.06);
    padding: 14px;
    width: 100%;
    box-sizing: border-box;
  }

  .warranty-review-card h2 {
    color: var(--rms-v2-text-title);
    font-size: 14px;
    font-weight: 700;
    line-height: 1.25;
    margin: 0 0 14px;
  }

  .warranty-review-row,
  .warranty-review-total-row {
    align-items: flex-start;
    display: flex;
    gap: 14px;
    justify-content: space-between;
    min-width: 0;
    padding: 7px 0;
  }

  .warranty-review-row span,
  .warranty-review-total-row span {
    color: var(--rms-v2-text-body);
    font-size: 12px;
    font-weight: 500;
  }

  .warranty-review-row strong,
  .warranty-review-total-row strong {
    color: var(--rms-v2-text-title);
    font-size: 12px;
    font-weight: 700;
    line-height: 1.35;
    min-width: 0;
    overflow-wrap: anywhere;
    text-align: right;
  }

  .warranty-review-total-row {
    border-top: 1px dashed var(--rms-v2-border);
    margin-top: 8px;
    padding-top: 12px;
  }

  .warranty-review-total-row strong {
    font-size: 14px;
    font-weight: 700;
  }

  .warranty-review-muted-row span,
  .warranty-review-muted-row strong {
    color: var(--rms-v2-text-muted);
    font-weight: 600;
  }

  .warranty-review-note {
    align-items: flex-start;
    background: ${(props) => `${props.primaryColor || "#2f80ed"}0F`};
    border: 1px solid ${(props) => `${props.primaryColor || "#2f80ed"}33`};
    border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
    color: var(--rms-v2-text-body);
    display: flex;
    gap: 10px;
    margin-top: 12px;
    padding: 10px;
  }

  .warranty-review-note svg {
    color: ${(props) => props.primaryColor || "#2f80ed"};
    flex: 0 0 22px;
    height: 22px;
    width: 22px;
  }

  .warranty-review-note p {
    color: var(--rms-v2-text-body);
    font-size: 12px;
    line-height: 1.45;
    margin: 0;
  }

  .warranty-card-toggle {
    align-items: center;
    background: transparent;
    border: 0;
    color: var(--rms-v2-text-title);
    cursor: pointer;
    display: flex;
    font: inherit;
    justify-content: space-between;
    margin: 0;
    padding: 0;
    text-align: left;
    width: 100%;
  }

  .warranty-card-toggle:focus-visible {
    outline: 2px solid ${(props) => props.primaryColor || "#2f80ed"};
    outline-offset: 4px;
  }

  .warranty-card-toggle span {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }

  .warranty-card-toggle strong {
    color: var(--rms-v2-text-title);
    font-size: 14px;
    font-weight: 700;
    line-height: 1.25;
  }

  .warranty-card-toggle small {
    color: var(--rms-v2-text-muted);
    font-size: 12px;
    font-weight: 500;
    line-height: 1.35;
  }

  .warranty-card-toggle svg {
    color: ${(props) => props.primaryColor || "#2f80ed"};
    flex: 0 0 24px;
    height: 24px;
    transform: rotate(0deg);
    transition: transform 160ms ease;
    width: 24px;
  }

  .warranty-card-toggle svg.open {
    transform: rotate(180deg);
  }

  .warranty-component-list {
    margin-top: 12px;
  }

  .warranty-component-row {
    align-items: center;
    border-top: 1px solid var(--rms-v2-border-soft);
    display: grid;
    gap: 12px;
    grid-template-columns: auto minmax(0, 1fr) auto;
    min-height: 46px;
    padding: 10px 0;
  }

  .warranty-component-row.no-image {
    grid-template-columns: minmax(0, 1fr) auto;
  }

  .warranty-component-row:first-child {
    border-top: 0;
  }

  .warranty-component-row img {
    background: var(--rms-v2-surface-muted);
    border: 1px solid var(--rms-v2-border-soft);
    border-radius: ${(props) => (props.rounded ? "8px" : "0px")};
    height: 40px;
    object-fit: contain;
    width: 40px;
  }

  .warranty-component-row span {
    color: var(--rms-v2-text-body);
    font-size: 12px;
    font-weight: 600;
    min-width: 0;
    overflow-wrap: anywhere;
  }

  .warranty-component-row strong {
    color: var(--rms-v2-text-title);
    font-size: 12px;
    font-weight: 800;
    white-space: nowrap;
  }

  .warranty-component-footnote {
    color: var(--rms-v2-text-muted);
    font-size: 12px;
    line-height: 1.4;
    margin: 2px 0 0;
  }

  .warranty-next-card {
    padding-bottom: 8px;
  }

  .warranty-next-steps {
    display: flex;
    flex-direction: column;
  }

  .warranty-next-step {
    align-items: center;
    border-top: 1px solid var(--rms-v2-border-soft);
    display: grid;
    gap: 14px;
    grid-template-columns: 24px minmax(0, 1fr);
    min-height: 50px;
    padding: 9px 0;
  }

  .warranty-next-step:first-child {
    border-top: 0;
  }

  .warranty-next-step span {
    align-items: center;
    background: ${(props) => props.primaryColor || "#2f80ed"};
    border-radius: 50%;
    color: var(--rms-v2-surface);
    display: inline-flex;
    font-size: 13px;
    font-weight: 900;
    height: 24px;
    justify-content: center;
    width: 24px;
  }

  .warranty-next-step p {
    color: var(--rms-v2-text-title);
    font-size: 12px;
    font-weight: 600;
    line-height: 1.35;
    margin: 0;
  }

  @media (prefers-reduced-motion: reduce) {
    .warranty-card-toggle svg {
      transition: none;
    }
  }

  .v2-address-section {
    display: block !important;
    padding: 14px;
    background: var(--rms-v2-surface);
    border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
  }

  .v2-address-section .pickup > span,
  .v2-address-section .pickup .change {
    display: none;
  }

  .v2-address-header-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
    margin-bottom: 0.5rem;
  }

  .v2-address-header-row > p {
    margin: 0;
    color: var(--rms-v2-text-title);
    font-size: 14px;
    font-weight: 700;
  }

  .v2-address-edit-btn {
    border: 0;
    background: transparent;
    color: ${(props) => props.primary_color || "#2563eb"};
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    padding: 4px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .v2-address-edit-btn svg {
    height: 18px;
    width: 18px;
  }

  .v2-address-editor {
    margin-top: 10px;
    padding: 0;
    border: 0;
    background: transparent;
    animation: v2ActionSlideDown 220ms ease-out;
  }

  .v2-address-editor .MuiInputBase-input,
  .v2-address-editor .MuiInputLabel-root,
  .v2-address-editor .MuiFormHelperText-root {
    font-size: 12px;
  }

  .v2-address-section hr {
    display: none;
  }

  .v2-address-editor-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
    margin-top: 1rem;
  }

  .v2-address-editor-grid .MuiFormControl-root {
    grid-column: span 1;
    font-size: 12px;
    margin-bottom: 10px;
  }

  .v2-address-editor-grid .MuiFormControl-root:nth-child(5),
  .v2-address-editor-grid .MuiFormControl-root:nth-child(6),
  .v2-address-editor-grid .MuiFormControl-root:nth-child(9) {
    grid-column: 1 / -1;
  }

  .v2-address-editor-grid .Mui-error,
  .v2-address-editor-grid .MuiFormLabel-root.Mui-error,
  .v2-address-editor-grid .MuiFormHelperText-root.Mui-error {
    color: var(--rms-v2-danger) !important;
  }

  .v2-address-editor-grid .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline {
    border-color: var(--rms-v2-danger) !important;
  }

  .v2-address-editor-error {
    margin: 10px 0 0;
    color: var(--rms-v2-danger);
    font-size: 12px;
    font-weight: 600;
  }

  .v2-address-editor-actions {
    margin-top: 10px;
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }

  .v2-address-editor-actions .v2-address-cancel-button {
    border: 1px solid var(--rms-v2-text-title) !important;
    background: transparent !important;
    color: var(--rms-v2-text-title) !important;
    -webkit-text-fill-color: var(--rms-v2-text-title);
    box-shadow: none !important;
  }

  .v2-address-editor-actions .v2-address-save-button {
    border: 1px solid var(--rms-v2-text-title) !important;
    background: var(--rms-v2-text-title) !important;
    color: var(--rms-v2-surface) !important;
    -webkit-text-fill-color: var(--rms-v2-surface);
    box-shadow: none !important;
  }

  .v2-address-editor-actions .v2-address-cancel-button:hover {
    background: var(--rms-v2-section-bg) !important;
  }

  .v2-address-editor-actions .v2-address-save-button:hover {
    background: var(--rms-v2-text-body) !important;
  }

  .v2-address-inline-error {
    margin: 0 0 1rem;
    color: var(--rms-v2-danger);
    font-size: 13px;
    animation: v2ActionSlideDown 220ms ease-out;
  }

  `;

export const StyledPaymentDiv = styled.div`
  .v2-refund-important-note {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px;
    margin-top: 12px;
    border-left: 4px solid var(--rms-v2-warning);
    border-radius: 4px;
    background: var(--rms-v2-warning-soft);
    color: var(--rms-v2-text-title);
    font-size: 13px;
    line-height: 1.5;
  }

  .v2-refund-important-note > svg {
    flex-shrink: 0;
    color: var(--rms-v2-warning);
  }

  .v2-refund-important-note p {
    margin: 0;
  }

  .v2-refund-important-note-title {
    font-weight: 700;
  }

  background: var(--rms-v2-surface);
  padding: 14px;
  border-radius: var(--rms-v2-radius, 10px);
  box-shadow: 0 2px 8px rgba(16, 24, 40, 0.06);
  margin-bottom: 12px;

  .payment-title {
    font-size: 14px;
    color: var(--rms-v2-text-body);
    font-weight: 700;
    margin-bottom: 0.5rem;
  }

  .subtotal-statement {
    font-size: 14px;
    color: var(--rms-v2-text-body);
  }

  `;

export const StyledPaymentMode = styled.div`
  min-width: 100px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  margin-top: 10px;
  padding: 5px;
  font-size: 16px;
  border: ${(props) =>
    props.selected
      ? `1px solid ${props.primary_color}`
      : `1px solid  ${props.primary_color}33`};
  background: ${(props) =>
    props.selected && props.charges
        ? "var(--rms-v2-danger)"
        : props.selected
          ? props.primary_color
          : "transparent"};
  color: ${(props) => (props.selected ? "var(--rms-v2-surface)" : "")};

  :hover {
    background: ${(props) =>
      props.selected && props.charges
          ? "var(--rms-v2-danger)"
          : props.selected
            ? props.primary_color
            : `${props.primary_color}11`};
  }

  .handling-charges {
    background: var(--rms-v2-danger-soft);
    color: var(--rms-v2-danger);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 20px;
    padding: 2px 8px;
    border-radius: 999px;
    font-size: 10px;
    font-weight: 800;
    text-wrap: nowrap;
    line-height: 1;
  }

  ${(props) =>
    props.selected &&
    props.charges &&
    `
      .handling-charges {
        background: rgba(255, 255, 255, 0.18);
        color: var(--rms-v2-surface);
      }
    `}

  .refund-mode-offer-label {
    background: var(--rms-v2-success-soft);
    color: var(--rms-v2-success);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 20px;
    padding: 2px 8px;
    border-radius: 999px;
    font-size: 10px;
    font-weight: 800;
    text-wrap: nowrap;
    line-height: 1;
    margin: 0;
  }

  .payment-method-card {
    background: var(--rms-v2-surface);
    border: 1px solid var(--rms-v2-border);
    border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
    box-shadow: 0 2px 8px rgba(16, 24, 40, 0.06);
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin: 0;
    padding: 14px;
    width: 100%;
  }

  .payment-method-title {
    color: var(--rms-v2-text-title);
    font-size: 14px;
    font-weight: 700;
    margin: 0;
  }

  .payment-method-options {
    display: grid;
    gap: 10px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    width: 100%;
  }

  .payment-method-option {
    align-items: center;
    background: var(--rms-v2-surface-muted);
    border: 1px solid var(--rms-v2-border);
    border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
    color: var(--rms-v2-text-title);
    cursor: pointer;
    display: flex;
    font: inherit;
    font-size: 13px;
    font-weight: 700;
    gap: 10px;
    min-height: 44px;
    padding: 10px 12px;
    text-align: left;
  }

  .payment-method-option.selected {
    background: ${(props) => `${props.primary_color}08`};
    border-color: ${(props) => props.primary_color};
  }

  .payment-method-check {
    flex: 0 0 18px;
  }

  &.v2-refund-mode-card {
    width: 100%;
    min-width: 0;
    min-height: 72px;
    margin: 0;
    padding: 12px 14px;
    border: 1px solid
      ${(props) =>
        props.selected ? props.primary_color : "var(--rms-v2-border)"};
    background: ${(props) =>
      props.selected ? `${props.primary_color}08` : "var(--rms-v2-surface-muted)"};
    color: var(--rms-v2-text-title);
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
    text-align: left;
    box-shadow: none;
    font-family: inherit;
    appearance: none;
    text-transform: none;
    position: relative;
    cursor: pointer;
    max-height: ${(props) => (props.$hasOfferText ? "none" : "520px")};
    opacity: 1;
    overflow: hidden;
    transition:
      max-height 220ms ease,
      opacity 180ms ease,
      padding 220ms ease,
      border-width 220ms ease,
      min-height 220ms ease,
      transform 220ms ease;
  }

  &.v2-refund-mode-card-hidden {
    border-width: 0;
    max-height: 0;
    min-height: 0;
    margin-bottom: 0;
    opacity: 0;
    padding-bottom: 0;
    padding-top: 0;
    pointer-events: none;
    transform: translateY(-8px);
  }

  &.v2-refund-mode-card:hover {
    background: ${(props) =>
      props.selected ? `${props.primary_color}0D` : "var(--rms-v2-primary-faint)"};
  }

  &.v2-refund-mode-card .v2-checkmark-control {
    margin-left: auto;
  }

  .v2-refund-mode-icon {
    width: 40px;
    height: 40px;
    flex: 0 0 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: var(--rms-v2-border-soft);
    color: var(--rms-v2-text-muted);
  }

  &.v2-refund-mode-card .v2-refund-mode-icon svg {
    color: inherit;
  }

  &.v2-refund-mode-card .v2-refund-mode-icon svg path {
    fill: currentColor;
    stroke: currentColor;
  }

  &.v2-refund-mode-card .v2-refund-mode-icon {
    background: ${(props) =>
      props.selected ? "var(--rms-v2-primary-soft)" : "var(--rms-v2-border-soft)"};
    color: ${(props) =>
      props.selected ? props.primary_color : "var(--rms-v2-text-muted)"};
  }

  .v2-refund-mode-copy {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 3px;
    flex: 1;
  }

  .v2-refund-mode-title-row {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }

  .v2-refund-mode-title {
    color: var(--rms-v2-text-title);
    font-size: 14px;
    font-weight: 700;
    text-transform: none;
  }

  .v2-refund-mode-description {
    color: var(--rms-v2-text-muted);
    font-size: 12px;
    font-weight: 400;
    text-transform: none;
    margin-top: 4px;
  }

  .v2-refund-mode-offer {
    flex: 0 0 100%;
    color: ${(props) => props.primary_color};
    font-size: 13px;
    font-weight: 400;
    line-height: 1.5;
    text-transform: none;
  }

  .line-item-refund-policy-review {
    border-top: 1px solid var(--rms-v2-border, #e5e7eb);
    display: grid;
    gap: 6px;
    margin-top: 8px;
    padding-top: 8px;
  }

  .line-item-refund-policy-review > div {
    align-items: baseline;
    display: flex;
    gap: 12px;
    justify-content: space-between;
  }

  .line-item-refund-policy-review span {
    color: var(--rms-v2-text-muted);
    font-size: 12px;
  }

  .line-item-refund-policy-review strong {
    font-size: 12px;
    text-align: right;
  }

  .v2-refund-mode-badges {
    position: absolute;
    right: 0;
    top: 0;
    font-weight: 700;
    z-index: 1;
  }

  .v2-refund-bank-inline-form {
    flex: 0 0 100%;
    display: grid;
    gap: 12px;
    margin-top: 6px;
  }

  .v2-refund-bank-inline-divider {
    height: 1px;
    background: var(--rms-v2-border-soft);
    margin: 2px 0 4px;
  }

  .v2-refund-bank-inline-title {
    margin: 0;
    color: ${(props) => props.primary_color};
    font-size: 12px;
    font-weight: 900;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  .v2-refund-bank-inline-form .MuiInputBase-root {
    background: var(--rms-v2-surface);
  }

  .v2-refund-bank-inline-form .MuiOutlinedInput-notchedOutline {
    border: 0 !important;
  }

  .v2-refund-bank-inline-form .MuiFormHelperText-root.Mui-error {
    color: var(--rms-v2-danger);
    font-size: 11px;
    font-weight: 600;
    margin-left: 10px;
  }

  .v2-refund-bank-inline-form .MuiInputBase-input {
    min-height: 42px;
    padding: 0 14px;
  }

  .v2-refund-inline-summary {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    padding: 10px 12px;
    border: 1px solid var(--rms-v2-border-soft);
    border-radius: 10px;
    background: var(--rms-v2-surface);
  }

  .v2-refund-inline-success {
    margin: 0;
    color: var(--rms-v2-success);
    font-size: 12px;
    font-weight: 800;
  }

  .v2-refund-inline-value {
    margin: 4px 0 0;
    color: var(--rms-v2-text-body);
    font-size: 13px;
    font-weight: 700;
  }

  .v2-refund-inline-edit {
    border: 0;
    background: transparent;
    color: ${(props) => props.primary_color};
    cursor: pointer;
    font-size: 12px;
    font-weight: 800;
    padding: 0;
  }

  .v2-refund-inline-error {
    margin: -4px 0 0;
    color: var(--rms-v2-danger);
    font-size: 12px;
    font-weight: 700;
  }

  .v2-refund-inline-save {
    height: 38px;
    min-height: 38px;
    border-radius: 10px !important;
    box-shadow: none !important;
    text-transform: capitalize !important;
    font-size: 13px !important;
    font-weight: 800 !important;
  }
`;
